import { apiRequest } from '../../apiCall'

import { callQueue, callQueueBody, callQueueCustomerMember, defaultMusic } from '../../types/Queues/apiRequestType'

export const insertQueueRequest = (params: callQueue) =>  apiRequest('queue.InsertCallQueue', params, '', true)
export const deleteQueueRequest = (id: string) =>    apiRequest('queue.DeleteCallQueue', {}, `?CallQueueId=${id}`, true)
export const editQueue=(params: callQueue) => apiRequest('queue.UpdateCallQueue', params, '', true)
export const getQueueRequest = (params:callQueueBody) => apiRequest('queue.GetAllCallQueue', params, '', true)
export const uploadDefaultMusic = (params:defaultMusic) =>apiRequest(`queue.UploadDefaultCallQueueMusic`, {}, `?CallQueueId=${params.CallQueueId}&url=${params.url}`, true) 
export const getActiveQueue = (id: string) =>apiRequest('queue.GetActiveCallQueue', {}, `?CallQueueId=${id}`, true)
    
   


